import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppSettings } from '../../../utils/app-settings';
import { SchoolInfoService } from './school-info.service'

@Component({
  selector: 'app-school-logo',
  templateUrl: './school-logo.component.html',
  styleUrls: ['./school-logo.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class SchoolLogoComponent implements OnInit {

  constructor(private schoolInfoService: SchoolInfoService) { }

  siteUrl = AppSettings.siteUrl;
  schoolName: string ;

  ngOnInit() {
    this.schoolInfoService.getInstitutionInfo().subscribe(res => {
      this.schoolName = res.institute_name
    })
  }

}
